import { useState } from "react";
import ParcelIncidentBadge from "../../components/ParcelIncidentBadge";
import Button from "../../components/InputComponents/Button";
import Declaration from "./Declaration";
import Line from "../../components/InputComponents/Line";
import Transportation from "./Transportation";
import ChangeDeliveryAddress from "./ChangeDeliveryAddress";
import AddTrustedPerson from "./AddTrustedPerson";
//images
import { useTranslation } from "react-i18next";
import axiosClient from "../../api/api";
import PriceInfoButton from "../../components/PriceExplain/PriceInfoButton";
import { BiChevronDown } from "react-icons/bi";
import { BsAirplane, BsTruck, BsExclamationCircle } from "react-icons/bs";
import { FaShip } from "react-icons/fa";
import DeclarationDetails from "./DeclarationDetails";

const SentCard = ({ data, payPack, setUpdatePacks, payPackBonusPoints }) => {
    const { t } = useTranslation();
    //dparcel information popup
    const [detailsShow, setDetailsShow] = useState(false);
    //dparcel information popup
    const [decShow, setDecShow] = useState(false);
    //action toggle
    const [toggleActions, setToggleActions] = useState(false);
    //action toggle
    const [toggleTransactions, setToggleTransactions] = useState(false);
    //show trusted person popup
    const [trustedShow, setTrustedShow] = useState(false);
    //update date
    const [updateDate, setUpdateDate] = useState(() => {
        if (data.shipment !== null) {
            const date = new Date(
                data.shipment.updated_at
            ).toLocaleDateString();
            return date;
        } else {
            return "...";
        }
    });

    return (
        <div
            className={`p-4 flex items-center md:items-start
        md:shadow-bs1 md:rounded-lg md:bg-white relative`}
        >
            {/* Border Declaration Badge */}
            {(data?.border_declar ?? 0) !== 0 && (
                <div className={`absolute top-2 right-2 px-2 py-1 rounded text-xs font-bold text-white z-10 ${
                    (data?.border_declar ?? 0) === 1 ? 'bg-red-500' :
                    (data?.border_declar ?? 0) === 2 ? 'bg-green-500' :
                    (data?.border_declar ?? 0) === 3 ? 'bg-yellow-500' :
                    'bg-gray-500'
                }`}>
                    {(data?.border_declar ?? 0) === 1 ? t('border_declar_needs_declaration') :
                     (data?.border_declar ?? 0) === 2 ? t('border_declar_declared') :
                     (data?.border_declar ?? 0) === 3 ? t('border_declar_in_customs') :
                     t('border_declar_not_needed')}
                </div>
            )}
            <div className="w-full grid grid-cols-8 md:grid-cols-2 gap-2 sm:gap-y-5">
                <div className="w-full flex flex-row gap-2.5 col-span-2">
                    <div>
                        {data.shipment_type === 1 && (
                            <BsTruck className="text-2xl text-teal_600" />
                        )}
                        {data.shipment_type === 2 && (
                            <BsAirplane className="text-2xl text-teal_600" />
                        )}
                        {data.shipment_type === 3 && (
                            <FaShip className="text-2xl text-teal_600" />
                        )}
                    </div>
                    <div className="flex flex-col gap-1">
                        <p className="text-sm md:text-xs text-teal_600 font-semibold">
                            {data.tracking_number}
                        </p>
                        <ParcelIncidentBadge incident={data.incident} />
                        <div className="flex items-center gap-2">
                            <p className="text-xs text-gray-500 font-normal">
                                {data.country.country}
                            </p>
                            <div className="flex justify-between items-center">
                                <div className="group relative">
                                    <BsExclamationCircle className="text-gray_900 w-4 h-4 hover:text-teal-600 cursor-pointer" />
                                    <div className="hidden group-hover:block absolute bottom-[100%] left-0 w-[300px] z-[2]">
                                        <div
                                            className="flex flex-col w-full bg-white border border-gray-200 shadow-bs1
                            rounded-[30px]"
                                        >
                                            <div className="flex flex-col gap-1 p-4">
                                                <p className="text-xs font-semibold">
                                                    {data.shipment_code}
                                                </p>
                                                <p className="text-xs font-semibold">
                                                    {t("last_updated")}:
                                                </p>
                                                <p className="text-xs font-semibold">
                                                    {updateDate}
                                                </p>
                                            </div>
                                            {data.shipment && (
                                                <div className="flex flex-col gap-2 p-4 border-t border-gray-200">
                                                    {data.shipment.sent_at !==
                                                        "" &&
                                                        data.shipment
                                                            .sent_at && (
                                                            <div
                                                                div
                                                                className="flex flex-col gap-1"
                                                            >
                                                                <p className="text-xs font-semibold">
                                                                    {t(
                                                                        "sent_at"
                                                                    )}
                                                                </p>
                                                                <p className="text-teal_600 text-xs font-semibold">
                                                                    {
                                                                        data
                                                                            .shipment
                                                                            .sent_at
                                                                    }
                                                                </p>
                                                            </div>
                                                        )}
                                                    {data.shipment
                                                        .terminals_at && (
                                                        <div className="flex flex-col gap-1">
                                                            <p className="text-xs font-semibold">
                                                                {t(
                                                                    "terminals_at"
                                                                )}
                                                            </p>
                                                            <p className="text-teal_600 text-xs font-semibold">
                                                                {
                                                                    data
                                                                        .shipment
                                                                        .terminals_at
                                                                }
                                                            </p>
                                                        </div>
                                                    )}
                                                    {data.shipment
                                                        .customs_at && (
                                                        <div className="flex flex-col gap-1">
                                                            <p className="font-semibold text-xs">
                                                                {t(
                                                                    "customs_at"
                                                                )}
                                                            </p>
                                                            <p className="text-teal_600 text-xs font-semibold">
                                                                {
                                                                    data
                                                                        .shipment
                                                                        .customs_at
                                                                }
                                                            </p>
                                                        </div>
                                                    )}
                                                    {data.shipment
                                                        .redistribution_at && (
                                                        <div className="flex flex-col gap-1">
                                                            <p className="font-semibold text-xs">
                                                                {t(
                                                                    "redistribution_at"
                                                                )}
                                                            </p>
                                                            <p className="text-teal_600 text-xs font-semibold">
                                                                {
                                                                    data
                                                                        .shipment
                                                                        .redistribution_at
                                                                }
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full flex items-center">
                    <div className="flex flex-col gap-1">
                        <p className="text-xs md:text-xs text-teal_600 font-semibold">
                            {t("real_weight")}:{" "}
                            {data?.total_weight
                                ? `${data?.total_weight} ${t("kg")}`
                                : `0 ${t("kg")}`}
                        </p>
                        <p className="text-xs md:text-xs text-teal_600 font-semibold">
                            {t("volume_weight")}:{" "}
                            {data?.volume_weight
                                ? `${data?.volume_weight} ${t("kg")} (CBM)`
                                : `0 ${t("kg")}`}
                        </p>
                    </div>
                </div>
                <div className="w-full flex items-center">
                    <div className="flex flex-col gap-1">
                        <div className="flex items-center gap-1.5">
                           <p
                               className={`font-semibold text-sm md:text-xs ${
                                   data.transport_price === data.transport_paid
                                       ? "text-teal_600"
                                       : "text-red-400"
                               }`}
                           >
                               {data.transport_price.toFixed(2)} GEL
                           </p>
                           {/* Above ~10kg the price stops being self-evident — the tier comes
                               from the whole flight and volumetric weight may be in play — so the
                               breakdown is offered right where the number is. */}
                           {(
                              <PriceInfoButton
                                 fetcher={() =>
                                    axiosClient
                                       .get(`/packs/${data.id}/priceExplain`)
                                       .then(({ data: d }) => d)
                                 }
                              />
                           )}
                        </div>
                        <p className="text-xs text-gray-500 font-normal">
                            {t("price")}
                        </p>
                    </div>
                </div>
                <div className="w-full flex items-center">
                    <div className="flex flex-col gap-1">
                        <p className="text-sm md:text-xs text-teal_600 font-semibold">
                            {data.shipment_code}
                        </p>
                        <p className="text-xs text-gray-500 font-normal">
                            Shipment
                        </p>
                    </div>
                </div>
                <div className="w-full flex items-center">
                    <div className="flex flex-col gap-1">
                        <p className="text-sm md:text-xs text-teal_600 font-semibold">
                            {data.fine_price || 0} GEL
                        </p>
                        <p className="text-xs text-gray-500 font-normal">
                            {t("fine")}
                        </p>
                    </div>
                </div>
                <div className="w-full flex items-center">
                    {data.shipment !== null && (
                        <div className="flex flex-col gap-1">
                            <p className="text-sm md:text-xs text-teal_600 font-semibold">
                                {data.shipment.arrival_date !== null
                                    ? data.shipment.arrival_date
                                    : data.shipment.estemated_date !== null
                                    ? data.shipment.estemated_date
                                    : "---"}
                            </p>
                            <p className="text-xs text-gray-500 font-normal">
                                {data.shipment.arrival_date !== null
                                    ? t("arrival_date")
                                    : t("estimated_arrival_date")}
                            </p>
                        </div>
                    )}
                </div>
                <div className="w-full flex items-center">
                    <div className="relative w-full">
                        <div
                            className={`flex gap-2 items-center border-gray_300 border
                            rounded-lg p-2 cursor-pointer justify-between 
                            ${
                                data.packItems.length === 0 ||
                                data.packItems === null
                                    ? "bg-red-200"
                                    : "bg-white"
                            }`}
                            onClick={() => {
                                setToggleActions((prev) => !prev);
                            }}
                        >
                            <p className="text-xs text-gray-500 font-normal">
                                {t("action")}
                            </p>
                            <BiChevronDown
                                className={`transition-all text-teal_600 text-xl ${
                                    toggleActions && "rotate-180"
                                }`}
                            />
                        </div>
                        {toggleActions && (
                            <div
                                className="w-full flex gap-2 items-center absolute top-[110%] flex-col border-gray_300 border
                                rounded-lg p-2 z-30 bg-white"
                            >
                                {data.packItems.length === 0 ||
                                data.packItems === null ? (
                                    <Button
                                        className="cursor-pointer font-normal
                       text-sm text-center text-white_A700 w-full"
                                        shape="RoundedBorder8"
                                        size="unord"
                                        variant="OutlineTeal600_4"
                                        onClick={() => {
                                            setDecShow(true);
                                        }}
                                    >
                                        {t("declare")}
                                    </Button>
                                ) : (
                                    <Button
                                        className="cursor-pointer font-normal
                     text-sm text-center text-cyan_900 w-full"
                                        shape="RoundedBorder8"
                                        size="unord"
                                        variant="OutlineCyan900_1"
                                        onClick={() => {
                                            setDetailsShow(true);
                                        }}
                                    >
                                        {t("details")}
                                    </Button>
                                )}
                                <Button
                                    className="cursor-pointer font-normal
                       text-sm text-center text-white_A700 w-full"
                                    shape="RoundedBorder8"
                                    size="unord"
                                    variant="OutlineTeal600_4"
                                    onClick={() => {
                                        setTrustedShow(true);
                                    }}
                                >
                                    {t("trusted_person")}
                                </Button>
                                {data.transport_price ===
                                data.transport_paid ? (
                                    <Button
                                        className="cursor-pointer font-normal
text-sm text-center text-cyan_900 w-full"
                                        shape="RoundedBorder8"
                                        size="unord"
                                        variant="OutlineCyan900_1"
                                    >
                                        {t("paid")}
                                    </Button>
                                ) : (
                                    <Button
                                        className="h-full cursor-pointer font-normal
                      text-sm text-center text-white_A700 w-full"
                                        shape="RoundedBorder8"
                                        size="unord"
                                        variant="OutlineTeal600_4"
                                        onClick={() => {
                                            payPack(data.id);
                                        }}
                                    >
                                        {t("pay")}
                                    </Button>
                                )}
                                {data.transport_price !==
                                    data.transport_paid && (
                                    <Button
                                        className="h-full cursor-pointer font-normal
                      text-sm text-center text-white_A700 w-full"
                                        shape="RoundedBorder8"
                                        size="unord"
                                        variant="OutlineTeal600_4"
                                        onClick={() => {
                                            payPackBonusPoints(data.id);
                                        }}
                                    >
                                        {t("pay_with_points")}
                                    </Button>
                                )}
                                <Button
                                    className="h-full cursor-pointer font-normal
                      text-sm text-center text-white_A700 w-full"
                                    shape="RoundedBorder8"
                                    size="unord"
                                    variant="OutlineTeal600_4"
                                    onClick={() => {
                                        setToggleTransactions(true);
                                    }}
                                >
                                    {/* see ArrivedCard — door delivery only
                                        allows correcting the chosen address */}
                                    {data.home_delivery
                                        ? t("delivery_address")
                                        : t("courier")}
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {decShow && (
                <Declaration
                    setDecShow={setDecShow}
                    data={data}
                    setUpdatePacks={setUpdatePacks}
                />
            )}
            {detailsShow && (
                <DeclarationDetails setDecShow={setDetailsShow} data={data} />
            )}
            {toggleTransactions &&
                (data.home_delivery ? (
                    <ChangeDeliveryAddress
                        setDecShow={setToggleTransactions}
                        data={data}
                        setUpdatePacks={setUpdatePacks}
                    />
                ) : (
                    <Transportation
                        setDecShow={setToggleTransactions}
                        data={data}
                        setUpdatePacks={setUpdatePacks}
                    />
                ))}
            {trustedShow && (
                <AddTrustedPerson
                    setShow={setTrustedShow}
                    data={data}
                    setUpdatePacks={setUpdatePacks}
                />
            )}
        </div>
    );
};

export default SentCard;
